import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'hideIcon', 'showIcon', 'button']
  static values = {
    collapsed: { type: Boolean, default: false },
    hideText: { type: String, default: 'Hide folders' },
    showText: { type: String, default: 'Show folders' }
  }

  initialize() {
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    this.updateUI(true) 
  }

  updateUI(animate) {
    if (!this.hasContentTarget || !this.hasButtonTarget) return

    if (this.collapsedValue) {
      if (animate) {
        this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + 'px'
        this.contentTarget.offsetHeight
        this.contentTarget.style.maxHeight = '0px'
        this.contentTarget.style.margin = '0'
      } else {
        this.contentTarget.style.maxHeight = '0px'
        this.contentTarget.style.margin = '0'
      }
      this.contentTarget.style.overflow = 'hidden'
      
      if (this.hasHideIconTarget && this.hasShowIconTarget) {
        this.hideIconTarget.classList.add('hidden')
        this.showIconTarget.classList.remove('hidden', 'pointer-events-none')
      }
      
    } else {
      if (animate) {
        // Animate expand
        this.contentTarget.style.maxHeight = this.contentTarget.scrollHeight + 'px'
        this.contentTarget.style.margin = ''
        setTimeout(() => {
          if (!this.collapsedValue) {
            this.contentTarget.style.maxHeight = 'none'
            this.contentTarget.style.overflow = 'visible'
          }
        }, 300)
      } else {
        this.contentTarget.style.maxHeight = 'none'
        this.contentTarget.style.overflow = 'visible'
        this.contentTarget.style.margin = ''
      }
      
      if (this.hasHideIconTarget && this.hasShowIconTarget) {
        this.hideIconTarget.classList.remove('hidden')
        this.showIconTarget.classList.add('hidden', 'pointer-events-none')
      }
    }
  }
}

